import React from 'react'

const ProfileReport = () => {
    return (
        <div></div>
    )
}

export default ProfileReport